import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiPopover } from '@splashthat/sui';

import FontFamilyPickerOption from './FontFamilyPickerOption';

import Check from '../../icons/Check';

const BASE_CLASS_NAME = 'FontFamilyPickerPopover';

export default class FontFamilyPickerPopover extends Component {
    static propTypes = {
        showPopover: PropTypes.bool.isRequired,
        onClickClose: PropTypes.func.isRequired,
        anchorEl: PropTypes.object,
        minWidth: PropTypes.number.isRequired,
        onChangeFontFamily: PropTypes.func.isRequired,
        fontFamilyList: PropTypes.arrayOf(PropTypes.object).isRequired,
        defaultFontFamily: PropTypes.object.isRequired,
        className: PropTypes.string,
        qaId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        widthOptions: [],
        anchorEl: null,
        className: null,
    };

    wrapperRef = React.createRef();
    buttonRef = React.createRef();

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
        this.buttonRef && this.buttonRef.current && this.buttonRef.current.focus();
    }

    componentWillUnmount = () => {
        document.removeEventListener('click', this.handleOutsideClick, false);
    };

    handleOutsideClick = (event) => {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.props.onClickClose();
        }
    };

    handleClick = (id) => {
        this.props.onChangeFontFamily(id);
        this.props.onClickClose();
    };

    render() {
        const { fontFamilyList, showPopover, anchorEl, minWidth, defaultFontFamily, qaId } = this.props;

        const { value, id } = defaultFontFamily;

        const className = [BASE_CLASS_NAME, this.props.className].filter(Boolean).join(' ');

        return (
            <SuiPopover open={showPopover} anchorEl={anchorEl}>
                <div ref={this.wrapperRef}>
                    <SuiContainer className={className} style={{ minWidth }}>
                        {fontFamilyList.map((fontFamily) => (
                            <button
                                key={fontFamily.id}
                                className={`${BASE_CLASS_NAME}__content`}
                                onClick={() => this.handleClick(fontFamily.id)}
                                ref={value === fontFamily.value ? this.buttonRef : null}
                                data-qa={`${qaId}--option-${fontFamily.id}`}
                            >
                                <FontFamilyPickerOption font={fontFamily.value} />
                                {id === fontFamily.id ? <Check /> : null}
                            </button>
                        ))}
                    </SuiContainer>
                </div>
            </SuiPopover>
        );
    }
}
